export const DOMAIN = () => window.location.href
export const LOGIN_URL = () => 'https://d.drcnet.com.cn/eDRCNet.Common.Web/login/login.aspx?gourl=' + DOMAIN()
